var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile2User(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3C9.57 3 6.375 6.195 6.375 10.125C6.375 13.98 9.39 17.1 13.32 17.235C13.44 17.22 13.56 17.22 13.65 17.235C13.68 17.235 13.695 17.235 13.725 17.235C13.74 17.235 13.74 17.235 13.755 17.235C17.595 17.1 20.61 13.98 20.625 10.125C20.625 6.195 17.43 3 13.5 3Z",
    fill: "#FFE299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1204 21.225C16.9354 18.435 10.1104 18.435 5.89543 21.225C3.99043 22.5 2.94043 24.225 2.94043 26.07C2.94043 27.915 3.99043 29.625 5.88043 30.885C7.98043 32.295 10.7404 33 13.5004 33C16.2604 33 19.0204 32.295 21.1204 30.885C23.0104 29.61 24.0604 27.9 24.0604 26.04C24.0454 24.195 23.0104 22.485 21.1204 21.225Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.985 11.01C30.225 13.92 28.155 16.47 25.29 16.815C25.275 16.815 25.275 16.815 25.26 16.815H25.215C25.125 16.815 25.035 16.815 24.96 16.845C23.505 16.92 22.17 16.455 21.165 15.6C22.71 14.22 23.595 12.15 23.415 9.90003C23.31 8.68503 22.89 7.57503 22.26 6.63003C22.83 6.34503 23.49 6.16503 24.165 6.10503C27.105 5.85003 29.73 8.04003 29.985 11.01Z",
    fill: "#FFE299"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9853 24.885C32.8653 26.34 31.9354 27.6 30.3753 28.455C28.8754 29.28 26.9854 29.67 25.1104 29.625C26.1904 28.65 26.8203 27.435 26.9403 26.145C27.0903 24.285 26.2054 22.5 24.4354 21.075C23.4304 20.28 22.2604 19.65 20.9854 19.185C24.3004 18.225 28.4704 18.87 31.0354 20.94C32.4154 22.05 33.1203 23.445 32.9853 24.885Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile2User);
export default __webpack_public_path__ + "static/media/profile-2user.a7fc57794fd6d0e7330b0989987cfcb5.svg";
export { ForwardRef as ReactComponent };